export default __webpack_public_path__ + "static/media/logoekokom.e531c2e1.svg";